/**
 * Copy and behavior for Constellation plan-load failures.
 * Final user-facing messaging TBD by Frank — update strings in PLANS_UNAVAILABLE_COPY only.
 * Fallback mode TBD — switch PLANS_UNAVAILABLE_MODE when the approach is confirmed.
 */
export type PlansUnavailableMode = "message" | "educational" | "redirect";
export type PlansUnavailableReason = "empty_zip" | "api_error" | null;

export const PLANS_UNAVAILABLE_MODE: PlansUnavailableMode = "message";

export const PLANS_UNAVAILABLE_COPY = {
  kicker: "Plans temporarily unavailable",
  headline: "We're unable to load Constellation plans right now.",
  body: "Please try again shortly. We'll show Constellation rates and comparisons once our plans are available.",
  ctaLabel: "Try again",
  educationalHeadline: "Why choose Constellation?",
  educationalBody:
    "From stable rates to easy enrollment, Constellation makes managing your home energy simple, affordable, and reliable.",
  redirectMessage: "Taking you to Constellation for more ways to save.",
};

export const PLANS_UNAVAILABLE_EDUCATIONAL_ITEMS = [
  {
    title: "Fixed Rates",
    description: "Enjoy price stability for the duration of your plan terms",
  },
  {
    title: "Bill Credits",
    description: "Earn up to $50 back on your monthly bill",
  },
  {
    title: "Easy Setup",
    description: "Enroll online or over the phone in 5 minutes",
  },
  {
    title: "ETF Coverage",
    description: "We will cover your early termination fee up to $150",
  },
];

export const PLANS_UNAVAILABLE_REDIRECT_URL =
  "https://www.constellation.com/solutions/for-your-home/solutions-by-state/texas-energy.html";
